<section class="hero is-large is-info">
    <div class="hero-body">
        <p class="title">
            준비중입니다
        </p>
    </div>
</section>